var map = {
	"./telaPreta (1).jpg": 109,
	"./telaPreta (1).png": 3507,
	"./telaPreta (10).png": 2367,
	"./telaPreta (2).png": 7462,
	"./telaPreta (3).png": 7904,
	"./telaPreta (4).png": 7092,
	"./telaPreta (5).png": 2343,
	"./telaPreta (6).png": 7006,
	"./telaPreta (7).png": 8416,
	"./telaPreta (8).png": 148,
	"./telaPreta (9).png": 8664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6110;